import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Header, Button, Container, Grid, Message, Icon } from 'semantic-ui-react';
import numbro from 'numbro';

import {colors, fontSizes, fonts, layout, spacings, shadow, buttons} from 'style';
import ConfettiContainer from 'modules/misc/ConfettiContainer.js';
import withNavigation from 'modules/navigation/withNavigation.js';
import ProgressBar from 'modules/misc/ProgressBar.js';
import Utils from 'utils/Utils.js'

const style = {
    content: {
        marginLeft: 'auto',
        marginRight: 'auto',
        position: 'relative',
        padding: '40px 0px 20px 0px',
        textAlign: 'center',
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        backgroundColor: 'white',
        minHeight: '100%',
    },
    grid: {
        height: '100%'
    },
    body: {
        maxWidth: '320px',
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
        height: '100%',
    },
    header: {
        fontSize: fontSizes.h2,
        lineHeight: '1.5',
        color: colors.themeBlue,
        marginBottom: '20px'
    },
    continueButton: {
        ...buttons.base,
    },
    repeatButton: {
        ...buttons.base,
        backgroundColor: colors.pointsYellow,
        marginRight: spacings.tiny,
        marginLeft: spacings.tiny,
    },
    levelUpButton: {
        ...buttons.base,
        backgroundColor: colors.themeBlue,
        marginRight: spacings.tiny,
        marginLeft: spacings.tiny,
    },
    spacer: {
        height: '100px',
    },
    footer: {
        width: '100%',
        position: 'fixed',
        paddingBottom: '20px',
        left: '0',
        bottom: '0',
        backgroundColor: '#fff',
        zIndex: '5',
    },
    pointsLabel: {
        display: 'inline-block',
        color: '#fff',
        backgroundColor: colors.pointsYellow,
        height: '26px',
        borderRadius: '13px',
        padding: '6px 16px 6px 3px',
        verticalAlign: 'middle',
        margin: '0px 5px 0px 5px',
    },
    resourceLabel: {
        display: 'inline-block',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        height: '26px',
        borderRadius: '13px',
        padding: '6px 16px 6px 3px',
        verticalAlign: 'middle',
        margin: '0px 5px 0px 5px',
    },
    pointsAward: {
        margin: '0px 5px 0px -95px',
        position: 'absolute',
        left: '50%',
        top: '0',
        display: 'block',
        color: '#fff',
        backgroundColor: '#fdd34f',
        height: '100px',
        width: '100px',
        borderRadius: '50%',
        zIndex: '2',
        boxShadow: '2px 2px 8px rgba(0,0,0,0.4)',
    },
    pointsAwardInnerCircle: {
        position: 'relative',
        top: '7px',
        left: '7px',
        padding: '6px 16px 6px 3px',
        background: 'linear-gradient(to top, #fcbd33, #fdd754)',
        borderRadius: '50%',
        height: '86px',
        width: '86px',
        border: '1px solid #debe4b',
        boxShadow: '1px 1px 8px rgba(0,0,0,0.25) inset',
    },
    resourceAward: {
        margin: '0px 5px 0px -5px',
        position: 'absolute',
        left: '50%',
        top: '0',
        display: 'block',
        color: '#fff',
        backgroundColor: '#009acb',
        height: '100px',
        width: '100px',
        borderRadius: '50%',
        zIndex: '1',
        boxShadow: '2px 2px 8px rgba(0,0,0,0.4)',
    },
    resourceAwardInnerCircle: {
        position: 'relative',
        top: '7px',
        left: '7px',
        padding: '6px 16px 6px 3px',
        background: 'linear-gradient(to top, #0083bc, #00aed7)',
        borderRadius: '50%',
        height: '86px',
        width: '86px',
        border: '1px solid #008fb7',
        boxShadow: '1px 1px 8px rgba(0,0,0,0.25) inset',
    },
    iconAward: {
        padding: '0px 12px 2px 8px',
        verticalAlign: 'middle',
        fontSize: '45px',
        position: 'relative',
        top: '-15px',
        textShadow: '2px 2px 8px rgba(0,0,0,0.25)',
    },
    icon: {
        padding: '0px 12px 6px 8px',
        verticalAlign: 'middle',
        fontSize: '16px',
        position: 'relative',
        top: '-1px',
    },
    iconSpan: {
        position: 'relative',
        top: '-3px',
    },
    awardRow: {
        position: 'relative',
        height: '110px',
        paddingBottom: '10px',
    },
    awardContent: {
        position: 'relative',
        top: '30px',
        left: '8px',
    },



    bannerWrapper: {
        position: 'absolute',
        top: '-25px',
        left: '50%',
        marginLeft: '-28px',
        borderRadius: '50%',
        height: '56x',
        width: '56px',
    },
    bannerImg: {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderRadius: '50%',
        height: '56px',
        width: '56px',
        verticalAlign: 'top',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        backgroundRepeat: 'no-repeat',
    },
    info: {
        position: 'relative',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        borderRadius: '60px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderWidth: '3px',
        boxShadow: '0px 3px 6px 3px rgba(0,0,0,0.2)',
        padding: '40px 30px 20px 30px',
        marginTop: '45px',
        marginBottom: '15px',
    },
    infoLabel: {
        paddingBottom: '10px',
    },
    progressBar: {
        boxShadow: 'none',
        marginTop: '6px',
        marginBottom: '6px',
        backgroundColor: '#fff',
    },
    healthGrade: {
        color: colors.themeTeal,
        marginBottom: spacings.large,
        fontSize: fontSizes.h1,
    },
    healthGradeLabel: {
        fontSize: fontSizes.bodyL,
        marginBottom: spacings.base,
    }
}

const Titles = {
    'activity': 'Activity Complete!',
    'level': 'Level up!',
    'survey': 'Survey Updated!',
    'log' : 'Log Complete!'
}

const UserChallengeComplete = ({t, progress, challenge, userChallenge, onContinue, onRepeatLevel}) => (
    <div style={style.content}>
            <Grid style={style.grid}>
                <Grid.Row verticalAlign='top'>
                    <Grid.Column verticalAlign='top' textAlign='center'>
                        <Header style={style.header}>
                            {t(Titles[progress.screen] || 'Activity Complete!')}
                        </Header>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column verticalAlign='middle' textAlign='center'>
                        <div style={style.body}>
                            {Boolean(progress && progress.health && progress.health.overall) &&
                                <div style={style.healthGrade}>
                                    <div style={style.healthGradeLabel}>{t('profile:::Your Health Grade')}</div>
                                    {numbro(progress.health.overall).format({trimMantissa: true, mantissa: 1, thousandSeparated: true})}
                                </div>
                            }
                            <div style={style.awardRow}>
                                <div style={style.pointsAward}>  
                                    <div style={style.pointsAwardInnerCircle}>
                                        <div style={style.awardContent}>
                                            <div>
                                                <i style={style.iconAward} className="icon-star"/>
                                            </div>
                                            <div>
                                                +{progress.award.points}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={style.resourceAward}>
                                    <div style={style.resourceAwardInnerCircle}>
                                        <div style={style.awardContent}>
                                            <div>
                                                <i style={style.iconAward} className="icon-Optimollar"/>
                                            </div>
                                            <div>
                                                +{progress.award.resources}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div>

                                <div style={style.pointsLabel}>  
                                    <span style={style.iconSpan}>
                                        <i style={style.icon} className="icon-star"/>
                                        {progress.userProfile.points}
                                    </span>
                                </div>
                                <div style={style.resourceLabel}>
                                    <span style={style.iconSpan}>
                                        <i style={style.icon} className="icon-Optimollar"/>
                                        {progress.userProfile.resources}
                                    </span>
                                </div>
                            </div>



                            <div style={style.info}>
                                {Boolean(userChallenge && userChallenge.challenge && userChallenge.challenge.category && userChallenge.challenge.category.badge) &&
                                    <div style={style.bannerWrapper}>
                                        <div style={{...style.bannerImg, backgroundImage:Utils.url(userChallenge.challenge.category.badge.url)}}></div>
                                    </div>
                                }
                                <div style={style.infoLabel}>{progress.label}</div>

                                {Boolean(progress.type=='generic') &&
                                    <div>
                                        {t('[count]_activity_completed', {count:progress.activitiesCompleted})}
                                    </div>
                                }
                                {Boolean(progress.type=='single') &&
                                    <div>
                                        <ProgressBar value={progress.activitiesCompleted} total={progress.activitiesRequired} style={style.progressBar} />
                                        <div>
                                            {t('{{percent}}% Completed', 
                                                {percent:Math.min(100,Math.max(0,Math.round(100*progress.activitiesCompleted/progress.activitiesRequired)))})}
                                        </div>
                                    </div>
                                }
                                {Boolean(progress.type=='double') &&
                                    <div>
                                        <ProgressBar value={progress.levelsCompleted} total={progress.levelsRequired} style={style.progressBar} />
                                        <div>
                                            {t('level_{{completed}}_{{required}}',
                                                {completed: Math.min(progress.levelsCompleted, progress.levelsRequired),
                                                 required: progress.levelsRequired})}
                                        </div>
                                        <ProgressBar value={progress.activitiesCompleted} total={progress.activitiesRequired} style={style.progressBar} />
                                        <div>
                                            {t('progress_{{completed}}_{{required}}_{{level}}',
                                                {completed: Math.min(progress.activitiesCompleted,progress.activitiesRequired),
                                                 required: progress.activitiesRequired,
                                                 level:progress.level})}
                                        </div>
                                    </div>
                                }

                            </div>

                        </div>
                    </Grid.Column>
                </Grid.Row>
              
                <Grid.Row verticalAlign='bottom'>
                    <Grid.Column verticalAlign='bottom' textAlign='center'>
                        {(progress.screen=='level') ? (
                                <Button.Group>
                                    <Button style={style.repeatButton} onClick={onRepeatLevel}>{t('Repeat Level')}</Button>
                                    <Button style={style.levelUpButton} onClick={onContinue}>{t('Level Up')}</Button>
                                </Button.Group>
                            ) : (
                                <Button style={style.continueButton} onClick={onContinue}>{t('Continue')}</Button>
                            )
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>



           
        <ConfettiContainer duration={3000} />
    </div>
);

export default withNavigation(translate(['challenges', 'profile'])(UserChallengeComplete), {enabled:false}, false);



// WEBPACK FOOTER //
// ./src/modules/challenges/UserChallengeComplete.js